<template>
    <el-form-item :label="`${labelText}`" :label-width="labelWidth">
      <div class="flexc-cen-x">
        <el-color-picker
          v-model="customerPaperwork[colorKey]"
          :disabled="backgroundOpacity"
        >
        </el-color-picker>
        <jd-button
          class="ml16"
          type="blueText"
          :disabled="backgroundOpacity"
          @click="customerPaperwork[colorKey] = resetColor"
          >重置</jd-button
        >
      </div>
    </el-form-item>
</template>
<script>
export default {
   props: {
    labelText: {
      type: String,
      default: "文字:",
    },
    labelWidth: {
      type: String,
      default: "",
    },
    colorKey: {
      type: String,
      default: "",
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    resetColor: {
      type: String,
      default: "#ffffff",
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
   },
   data() {
     return {
       
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
     
   },
   methods: {
     
   }
};
</script>
<style lang='scss' scoped>
.ml16 {
  margin-left: 16px;
}
</style>